import React from "react";
import TiltArrow from "../../../icons/TiltArrow";

interface props {
  propertyCount?: string;
  subAssetType?: string;
  locality?: string;
  imageLink?: string;
  propertyLink?: string;
  className?: string;
}

export const PropertiesCountCard = ({
  propertyCount,
  subAssetType,
  locality,
  imageLink,
  propertyLink,
  className,
}: props) => {
  return (
    <>
      <div
        className={`bg-brand-lightBlue pt-6 lg:pt-[34px] pb-[14px] lg:pb-[7px] px-[30px]  items-center lg:w-auto lg:h-[473px] ${className}`}
      >
        <div className="border-t-[1px] border-white  mr-[11px]" />
        {/*Card Heading  */}
        <div className=" w-full lg:max-w-[251px] mt-4 flex">
          <p className="max-w-[165px] font-openSans font-normal text-mobile-h3 lg:text-[32px]  mid:text-[37px] leading-[33px] lg:leading-[50px] text-brand-textBlack">
            {propertyCount} Properties
          </p>
          <a href={propertyLink} className="mt-auto ml-auto mb-[10px]">
            <TiltArrow height="42px" width="42px" bgFill={"#F1EAFF"} />
          </a>
        </div>
        {/* Image */}
        <div className="mt-[14px] h-[232px] lg:h-[267px] w-full clip-path-bottomRightPropertyCountCard">
          <img className="h-full w-full " src={imageLink} alt="" />
        </div>
        {/* Lower Part */}
        <div className="flex mt-[14px] lg:mt-[10px] items-center gap-2">
          <p className="capitalize font-openSans font-normal text-web-body-md  leading-6 text-brand-textBlack">
            {subAssetType}
          </p>
          <div className="bg-[#FF752C] h-[5px] w-[5px] rounded-full "></div>
          <p className="capitalize font-openSans font-normal text-web-body-md  leading-6 text-brand-textBlack">
            {locality}
          </p>
        </div>
      </div>
    </>
  );
};
